import { IErrorMessage } from '@hooks/use-error-message.ts';
import { DepartmentType } from '@models/departments-and-units/departments.model.ts';

export const departmentsErrorMessages: IErrorMessage = {
  departmentName: {
    required: 'validation_department_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  // department: {
  //   required: 'validation_department_required'
  // },
  description: {
    required: 'validation_description_required'
  },
  assignedAdmin: {
    required: 'validation_assigned_admin_required'
  },
  type: {
    required: 'validation_unit_type_required'
  }
};

export const DepartmentsStatusMap: Record<
  'true' | 'false',
  { text: string; color: string }
> = {
  true: {
    text: 'Active',
    color: 'var(--green-4)'
  },
  false: {
    text: 'Inactive',
    color: 'var(--pink)'
  }
};

export const departmentsFilterStatusOptions = [
  { title: 'Active', value: true },
  { title: 'Inactive', value: false }
];

export const departmentTypeList = [
  {
    id: 1,
    title: DepartmentType.ACCOUNTING_AND_FINANCE,
    value: DepartmentType.ACCOUNTING_AND_FINANCE
  },
  {
    id: 2,
    title: DepartmentType.HUMAN_RESOURCES,
    value: DepartmentType.HUMAN_RESOURCES
  },
  {
    id: 3,
    title: DepartmentType.FOOD_AND_BEVERAGE,
    value: DepartmentType.FOOD_AND_BEVERAGE
  },
  {
    id: 4,
    title: DepartmentType.FRONT_OFFICE,
    value: DepartmentType.FRONT_OFFICE
  },
  {
    id: 5,
    title: DepartmentType.HOUSEKEEPING,
    value: DepartmentType.HOUSEKEEPING
  },
  {
    id: 6,
    title: DepartmentType.SALES_AND_MARKETING,
    value: DepartmentType.SALES_AND_MARKETING
  },
  {
    id: 7,
    title: DepartmentType.MAINTENANCE_AND_ENGINEERING,
    value: DepartmentType.MAINTENANCE_AND_ENGINEERING
  },
  { id: 8, title: DepartmentType.SECURITY, value: DepartmentType.SECURITY },
  {
    id: 9,
    title: DepartmentType.IT_AND_SYSTEMS,
    value: DepartmentType.IT_AND_SYSTEMS
  },
  {
    id: 10,
    title: DepartmentType.SPA_AND_WELLNESS,
    value: DepartmentType.SPA_AND_WELLNESS
  },
  {
    id: 11,
    title: DepartmentType.EVENTS_AND_CONFERENCES,
    value: DepartmentType.EVENTS_AND_CONFERENCES
  },
  {
    id: 12,
    title: DepartmentType.TRANSPORT,
    value: DepartmentType.TRANSPORT
  }
];
